import { Suspense, lazy } from 'react'
import { Navigate } from 'react-router-dom'

import SuspenseLoader from 'src/components/SuspenseLoader'


// Agencies
import AgenciesProcess from '../scenes/process/agencies'
import Agency from '../scenes/process/agencies/Agency'

// Screens
import ScreensPage from '../scenes/process/screens'

// Screen Dashboard
import ScreenDashboardPage from '../scenes/process/screen-dashboard'

const Loader = (Component) => (props) =>
  (
    <Suspense fallback={<SuspenseLoader />}>
      <Component {...props} />
    </Suspense>
  )


const processRoutes = [
  {
    path: 'agencies',
    element: <AgenciesProcess />,
  },
  {
    path: 'agencies/:id',
    element: <Agency />,
  },
  {
    path: 'screens',
    element: <ScreensPage />,
  },
  {
    path: 'screen-dashboard',
    element: <ScreenDashboardPage />,
  },
]

export default processRoutes

